import React, { memo, useCallback } from 'react';
import { GoogleIcon } from '../Icons';
import {
  GoogleLoginResponse,
  GoogleLoginResponseOffline,
  useGoogleLogin,
} from 'react-google-login';

import './GoogleButton.css';
import { useGoogleSignInMutation } from '../../apis/mlkApi/mlk.api.hooks';
import { useHistory } from 'react-router';
import { Config } from '../../helpers/config';
import { useSelector } from 'react-redux';
import { getOperationSelector } from '../../redux/general/general.selectors';
import { parseRes } from '../../apis/utils';
import { handleSignIn } from '../../helpers/auth';

type GoogleButtonProps = {};

export const GoogleButton: React.FC<GoogleButtonProps> = memo(() => {
  const history = useHistory();
  const [googleSignIn] = useGoogleSignInMutation();
  const operation = useSelector(getOperationSelector);

  const onSignInSuccess = useCallback(
    (response: GoogleLoginResponse | GoogleLoginResponseOffline) => {
      const castedResponse = response as GoogleLoginResponse;
      if (castedResponse.tokenId !== undefined) {
        googleSignIn({ idToken: castedResponse.tokenId }).then((res) => {
          const { successRes, errorRes } = parseRes(res);
          handleSignIn(successRes, operation, history);
          if (errorRes.error) {
            // TODO: Handle error
          }
        });
      }
    },
    [googleSignIn, history, operation]
  );

  const onSignInFailure = useCallback((error) => {
    // TODO: Handle login failure
    console.log(error);
  }, []);

  const { signIn } = useGoogleLogin({
    clientId: Config.googleSignInClientId!,
    autoLoad: false,
    onSuccess: onSignInSuccess,
    onFailure: onSignInFailure,
  });

  return (
    <>
      <button onClick={signIn} type="button" className="google-button--button">
        <span className="google-button--icon">
          <GoogleIcon />
        </span>
        <span className="google-button--text">Google</span>
      </button>
    </>
  );
});
